import { motion } from "framer-motion";
import { EXPERIENCES } from "@/data/content";

export const Experiences = () => {
  return (
    <section
      data-testid="experiences-section"
      id="experiences"
      className="relative py-24 md:py-32 bg-[#faf6ef]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <p className="font-body-lux text-xs uppercase tracking-[0.35em] text-[#9c7d44] mb-8">
              Experiences
            </p>
            <h2 className="font-serif-lux font-light leading-[1.1] tracking-tight text-[#1f3a2e] text-4xl sm:text-5xl">
              A country of contrasts,
              <br />
              woven into one journey.
            </h2>
          </div>
          <p className="font-body-lux text-sm font-light text-[#47564d] max-w-sm leading-relaxed">
            These are starting points — never fixed itineraries. Your holiday is
            composed from moments like these, tuned entirely to you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {EXPERIENCES.map((exp, i) => (
            <motion.div
              key={exp.title}
              data-testid={`experience-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className={`group relative overflow-hidden cursor-pointer ${
                i % 3 === 0 ? "md:row-span-2" : ""
              }`}
            >
              <div className="absolute -inset-0 border border-transparent group-hover:border-[#b8965a] transition-colors duration-500 z-20 pointer-events-none" />
              <div
                className={`overflow-hidden ${
                  i % 3 === 0 ? "h-[420px] md:h-[600px]" : "h-[420px] md:h-[284px]"
                }`}
              >
                <img
                  src={exp.image}
                  alt={exp.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#1f3a2e] via-[#1f3a2e]/25 to-transparent" />
              <div className="absolute bottom-0 left-0 p-8 md:p-10 z-10">
                <p className="font-body-lux text-xs uppercase tracking-[0.25em] text-[#e6c98a] mb-3">
                  {exp.tag}
                </p>
                <h3 className="font-serif-lux text-3xl md:text-4xl text-[#fdfbf7]">
                  {exp.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
